import { render, staticRenderFns } from "./wechat_reg.vue?vue&type=template&id=f9c8b3ee&"
import script from "./wechat_reg.vue?vue&type=script&lang=js&"
export * from "./wechat_reg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports